import { useState, useEffect } from "react";
import logo from '../assets/images/logo.png'
import { BsMoonStars } from "react-icons/bs";
import { MdOutlineWbSunny } from "react-icons/md";
import UserImage from '../assets/images/user.png'
import { FaUserLarge } from "react-icons/fa6";
import { MdLogout } from "react-icons/md";
import { useNavigate } from 'react-router-dom'


export default function Header() {

    const navigate = useNavigate()
    const [isOpen, setIsOpen] = useState(false);
    const [isDark, setIsDark] = useState(() => {
        // Check if user has a theme preference in localStorage
        const savedTheme = localStorage.getItem('theme');
        return savedTheme === 'dark';
    });
    const [userDetails, setUserDetails] = useState(null);
    const storedUserName = localStorage.getItem('loggedUser');
    const storedUserId = localStorage.getItem('loggedUserId');

    useEffect(() => {
        const storedUserDetails = localStorage.getItem('userBankDetails');
        if (storedUserDetails) {
            setUserDetails(JSON.parse(storedUserDetails));
        }
    }, []);

    // Handle theme changes
    useEffect(() => {
        if (isDark) {
            document.documentElement.classList.add('dark');
            localStorage.setItem('theme', 'dark');
        } else {
            document.documentElement.classList.remove('dark');
            localStorage.setItem('theme', 'light');
        }
    }, [isDark]);

    const handleLogout = () => {
        localStorage.clear()
        setIsOpen(false)
        navigate('/')
    }


    useEffect(() => {
        const handleClickOutside = (event) => {
            const dropdown = document.getElementById('dropdown-user');
            if (dropdown && !dropdown.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);


    return (
        <nav className="bg-[#FAFAFA] h-[80px] shadow-xl border-b-2 w-full ">
            <div className="max-w-screen-xxl h-full flex flex-wrap items-center justify-between mx-auto px-[50px]">
                {/* Logo */}
                <div className="flex h-full  items-center space-x-3 rtl:space-x-reverse">
                    <img onClick={() => navigate('/')} src={logo} className="h-[60px] cursor-pointer" alt="MoneyLions Logo" />
                    <span onClick={() => navigate('/')} className="self-center text-2xl font-semibold whitespace-nowrap dark:text-gray-900 cursor-pointer">
                        MoneyLions
                    </span>
                </div>


                <div className="flex md:order-2 items-center gap-10 space-x-3 md:space-x-0 rtl:space-x-reverse">

                    <label className="inline-flex items-center cursor-pointer">
                        {/* Hidden Checkbox */}
                        <input
                            type="checkbox"
                            checked={isDark}
                            onChange={() => setIsDark(!isDark)}
                            className="sr-only peer"
                        />

                        {/* Toggle Switch */}
                        <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-yellow-500 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-yellow-500 dark:peer-checked:bg-yellow-500">
                        </div>
                        {isDark ? (
                            <BsMoonStars size={20} className="text-gray-500 ms-4 dark:text-gray-400" />
                        ) : (
                            <MdOutlineWbSunny size={20} className="text-gray-500 ms-4 dark:text-gray-400" />
                        )}

                    </label>


                    <div className="relative">
                        <button
                            type="button"
                            className="flex text-sm  rounded-full focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600"
                            onClick={() => setIsOpen(!isOpen)}
                        >
                            <span className="sr-only">Open user menu</span>
                            <img className="w-10 h-10 rounded-full" src={UserImage} alt="user_photo" />
                        </button>
                        {isOpen && (
                            <div id="dropdown-user" className="absolute right-0 top-12 z-10 shadow-xl w-64 bg-[#f9f9f9] border border-gray-100 rounded-lg dark:border-gray-700">
                                <div className="py-3 flex items-center space-x-4 px-4">
                                    <img className="w-8 h-8 rounded-full" src={UserImage} alt="user_photo" />
                                    <div>
                                        <span className="block text-sm text-gray-900 dark:text-black"> {userDetails?.name || storedUserName || 'Guest'}</span>
                                        <span className="block text-sm text-gray-500 dark:text-black"> {userDetails?.userid || "@" + storedUserId || 'Guest'}</span>
                                    </div>
                                </div>

                                <div className="w-[90%] mx-auto flex flex-col my-4 gap-2">
                                    <div className="flex duration-300 hover:bg-violet-900 w-full items-center text-white font-bold gap-4 bg-violet-700 rounded-md px-4 py-2 cursor-pointer">
                                        <FaUserLarge size={20} className=" ms-4" />
                                        <p>Profile</p>
                                    </div>

                                    <div onClick={() => handleLogout()} className="flex duration-300 hover:bg-red-700 w-full items-center text-white font-bold gap-4 bg-red-500 rounded-md px-4 py-2 cursor-pointer">
                                        <MdLogout size={20} className=" ms-4" />
                                        <p>Logout</p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </nav>
    );
}
